import { FileType } from "@warda/library-ui/interfaces";
import getFileIcon from "@warda/library-ui/utils/getFileIcon";
import { SheetLayout, } from "../../../../interfaces";
import { getActions, getSelectAction } from "../getActions";
import { getQueryParams, updateSearchString } from "../../searchString";
import { isAreaTrash } from "../../areasUtils";
import { AREA } from "../../constants";
import { ACT_VPORT } from "../reducer";
import getFileAccess from "../utils/getFileAccess";
import isPortalConnectedToWebsite from "../utils/isWebsiteConnected";
export const itemsTypeSort = [FileType.FOLDER, FileType.MEDIA];
export const getFileTypeText = (type, multi = true) => {
    switch (type) {
        case FileType.PORTAL:
            return "Portal" + (multi ? "s" : "");
        case FileType.FOLDER:
            return "Folder" + (multi ? "s" : "");
        case FileType.MEDIA:
            return "Media";
        default:
            return "Undefined";
    }
};
export const needHeader = {
    [FileType.FOLDER]: 1,
    [FileType.MEDIA]: 1,
    [FileType.PORTAL]: 1,
};
export const needFooter = (files, filesTotal) => {
    return Object.fromEntries([FileType.FOLDER, FileType.MEDIA, FileType.PORTAL].map((type) => [
        type,
        needPagination({ type, files, filesTotal }).pagination ? 1 : 0,
    ]));
};
export const needPagination = ({ type, files, filesTotal, }) => {
    const countTotal = filesTotal[type];
    const countFiles = files.filter((f) => f.type === type).length;
    return {
        countTotal,
        countFiles,
        pagination: countFiles < countTotal,
    };
};
export const getAssetPropsFolder = ({ dispatchViewport, color, id, data, type, selected, selectedIds, selectedTypes, loading, onContextMenu, contextmenuOriginAnchor, contextmenuOriginTransf, contextmenuPosizionZone, permissions, queryHistory, querySearch, accessInherited, userId, }) => {
    const { area } = getQueryParams();
    const { name, owner, access } = data;
    const onClick = (_, { keyDownCtrl, keyDownMeta }) => {
        dispatchViewport({
            type: ACT_VPORT.SELECT_FILE_CLICK,
            id,
            keyDownCtrl,
            keyDownMeta,
        });
    };
    const onCheck = (_, { keyDownMeta }) => {
        dispatchViewport({
            type: ACT_VPORT.SELECT_FILE_CHECK,
            id,
            keyDownCtrl: true,
            keyDownMeta,
        });
    };
    const onNavigate = () => {
        dispatchViewport({ type: ACT_VPORT.NAVIGATION });
        updateSearchString({
            history: queryHistory,
            search: querySearch,
            path: id,
        });
    };
    const contextmenu = getActions({
        dispatchViewport,
        area,
        fileTypes: getSelectAction(selectedTypes, selected, type),
        access: getFileAccess({
            area,
            userId,
            owner,
            access,
            accessInherited,
        }),
        disabled: loading,
        permissions,
    });
    return {
        contextmenu,
        contextmenuOriginAnchor,
        contextmenuOriginTransf,
        contextmenuPosizionZone,
        onContextMenu,
        onDoubleClick: onNavigate,
        onClick,
        onCheck,
        color,
        selected,
        icon: "folder",
        label: name,
        checkbox: !!selectedIds.length ? "mousehover" : "none",
    };
};
export const getAssetPropsMedia = ({ dispatchViewport, color, id, data, type, selected, selectedIds, selectedTypes, loading, onContextMenu, contextmenuOriginAnchor, contextmenuOriginTransf, contextmenuPosizionZone, permissions, accessInherited, userId, mimeTypeToMediaKind, }) => {
    const { area } = getQueryParams();
    const { name, owner, access, mimeType } = data;
    const icon = getFileIcon(mimeType, mimeTypeToMediaKind);
    const onClick = (_, { keyDownCtrl, keyDownMeta }) => {
        dispatchViewport({
            type: ACT_VPORT.SELECT_FILE_CLICK,
            id,
            keyDownCtrl,
            keyDownMeta,
        });
    };
    const onCheck = (_, { keyDownMeta }) => {
        dispatchViewport({
            type: ACT_VPORT.SELECT_FILE_CHECK,
            id,
            keyDownCtrl: true,
            keyDownMeta,
        });
    };
    const onDetail = () => {
        dispatchViewport({
            type: ACT_VPORT.SELECT_FILE_CLICK,
            id,
            keyDownCtrl: false,
            keyDownMeta: false,
            detailLayout: SheetLayout.MEDIA_ZOOM,
        });
    };
    const contextmenu = getActions({
        dispatchViewport,
        area,
        fileTypes: getSelectAction(selectedTypes, selected, type),
        access: getFileAccess({
            area,
            userId,
            owner,
            access,
            accessInherited,
        }),
        disabled: loading,
        permissions,
    });
    return {
        contextmenu,
        contextmenuOriginAnchor,
        contextmenuOriginTransf,
        contextmenuPosizionZone,
        onContextMenu,
        onDoubleClick: onDetail,
        onClick,
        onCheck,
        color,
        selected,
        icon,
        label: name,
        checkbox: !!selectedIds.length ? "mousehover" : "none",
    };
};
export const getAssetPropsPortal = ({ dispatchViewport, color, id, data, type, selected, selectedIds, selectedTypes, loading, onContextMenu, contextmenuOriginAnchor, contextmenuOriginTransf, contextmenuPosizionZone, permissions, queryHistory, querySearch, userId, selection, }) => {
    const { area } = getQueryParams();
    const { name, access, owner } = data;
    const trash = isAreaTrash();
    const onClick = (_, { keyDownCtrl, keyDownMeta }) => {
        dispatchViewport({
            type: ACT_VPORT.SELECT_FILE_CLICK,
            id,
            keyDownCtrl,
            keyDownMeta,
        });
    };
    const onCheck = (_, { keyDownMeta }) => {
        dispatchViewport({
            type: ACT_VPORT.SELECT_FILE_CHECK,
            id,
            keyDownCtrl: true,
            keyDownMeta,
        });
    };
    const onNavigate = () => {
        dispatchViewport({ type: ACT_VPORT.NAVIGATION });
        updateSearchString({
            history: queryHistory,
            search: querySearch,
            area: trash ? AREA.TRASH_PORTAL : AREA.PORTAL,
            path: trash ? id + "_-1" : id + "_0",
        });
    };
    const disabled = data.empty === true;
    const tooltip = disabled
        ? "There are no deleted elements in this portal’s bin"
        : undefined;
    const contextmenu = getActions({
        dispatchViewport,
        area,
        fileTypes: getSelectAction(selectedTypes, selected, type),
        access: getFileAccess({
            area,
            userId,
            owner,
            access,
        }),
        disabled: disabled || loading,
        permissions,
        selection,
    });
    return {
        contextmenu,
        contextmenuOriginAnchor,
        contextmenuOriginTransf,
        contextmenuPosizionZone,
        onContextMenu,
        onDoubleClick: onNavigate,
        onClick,
        onCheck,
        color,
        selected,
        icon: isPortalConnectedToWebsite({ data }) ? "cast_connected" : "cast",
        label: name,
        checkbox: !!selectedIds.length ? "mousehover" : "none",
        disabled,
        tooltip,
    };
};
